export default __webpack_public_path__ + "static/media/signin.8e84944a.png";